import { setLoading, setOrders, setOrder, orderCreated, orderUpdated, orderDeleted, setError } from "../slices/order"
import axios from "axios"

const getAuthToken = () => {
  try {
    const raw = localStorage.getItem("userInfo")
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.token || null
  } catch (e) {
    return null
  }
}

export const getOrders = () => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    const { data } = await axios.get("/api/orders", config)
    dispatch(setOrders(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred loading orders. Please try again later"
      )
    )
  }
}

export const getOrder = id => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    const { data } = await axios.get(`/api/orders/${id}`, config)
    dispatch(setOrder(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred loading order. Please try again later"
      )
    )
  }
}

export const createOrder = orderData => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      : { headers: { "Content-Type": "application/json" } }
    const { data } = await axios.post("/api/orders", orderData, config)
    dispatch(orderCreated(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred creating order. Please try again later"
      )
    )
    throw error
  }
}

export const updateOrder = (id, orderData) => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
      : { headers: { "Content-Type": "application/json" } }
    const { data } = await axios.put(`/api/orders/${id}`, orderData, config)
    dispatch(orderUpdated(data))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred updating order. Please try again later"
      )
    )
    throw error
  }
}

export const deleteOrder = id => async dispatch => {
  dispatch(setLoading())
  try {
    const token = getAuthToken()
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {}
    await axios.delete(`/api/orders/${id}`, config)
    dispatch(orderDeleted(id))
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred deleting order. Please try again later"
      )
    )
    throw error
  }
}
